module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('InnerMenu', {
    attrs: {
      "menu": _vm.menu
    }
  }, [_c('LoadingSpinner', {
    attrs: {
      "showContent": !_vm.loading,
      "size": 100
    }
  }, [_c('router-view', {
    attrs: {
      "profile": _vm.profile,
      "text": _vm.messageText,
      "color": _vm.errorColor,
      "errorsProp": _vm.errors,
      "isLoading": _vm.isSubmitingForm
    },
    on: {
      "changed": _vm.resetText,
      "submitUser": _vm.submit
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1d6ba6","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/settings/Settings.vue
// module id = 5c3714fca95a1647dcf3
// module chunks = 80